export default {
  SET_MUI_SIDEBAR_VISIBILITY: 'SET_MUI_SIDEBAR_VISIBILITY'
}
